/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadFilesVo } from './UploadFilesVo';
import {
    UploadFilesVoFromJSON,
    UploadFilesVoFromJSONTyped,
    UploadFilesVoToJSON,
    UploadFilesVoToJSONTyped,
} from './UploadFilesVo';

/**
 * 
 * @export
 * @interface ResponseUploadFilesVo
 */
export interface ResponseUploadFilesVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseUploadFilesVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseUploadFilesVo
     */
    message?: string;
    /**
     * 
     * @type {UploadFilesVo}
     * @memberof ResponseUploadFilesVo
     */
    data?: UploadFilesVo;
}

/**
 * Check if a given object implements the ResponseUploadFilesVo interface.
 */
export function instanceOfResponseUploadFilesVo(value: object): value is ResponseUploadFilesVo {
    return true;
}

export function ResponseUploadFilesVoFromJSON(json: any): ResponseUploadFilesVo {
    return ResponseUploadFilesVoFromJSONTyped(json, false);
}

export function ResponseUploadFilesVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUploadFilesVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : UploadFilesVoFromJSON(json['data']),
    };
}

export function ResponseUploadFilesVoToJSON(json: any): ResponseUploadFilesVo {
    return ResponseUploadFilesVoToJSONTyped(json, false);
}

export function ResponseUploadFilesVoToJSONTyped(value?: ResponseUploadFilesVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': UploadFilesVoToJSON(value['data']),
    };
}

